var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBuyMiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_959)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_89_959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 44C20.0444 44 16.1776 42.827 12.8886 40.6294C9.59962 38.4318 7.03617 35.3082 5.52242 31.6537C4.00867 27.9992 3.6126 23.9778 4.3843 20.0982C5.15601 16.2186 7.06082 12.6549 9.85787 9.85787C12.6549 7.06082 16.2186 5.15601 20.0982 4.3843C23.9778 3.6126 27.9992 4.00867 31.6537 5.52242C35.3082 7.03617 38.4318 9.59962 40.6294 12.8886C42.827 16.1776 44 20.0444 44 24C43.9942 29.3026 41.8852 34.3862 38.1357 38.1357C34.3862 41.8852 29.3026 43.9942 24 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8032 7.57549C27.5547 6.22993 23.9802 5.87787 20.5317 6.56383C17.0831 7.24979 13.9154 8.94296 11.4292 11.4292C8.9429 13.9155 7.24973 17.0832 6.56377 20.5317C5.87781 23.9803 6.22987 27.5548 7.57543 30.8033C8.92099 34.0517 11.1996 36.8282 14.1231 38.7817C17.0467 40.7351 20.4838 41.7778 24 41.7778C28.7133 41.7726 33.2322 39.8979 36.565 36.5651C39.8979 33.2322 41.7725 28.7134 41.7777 24",
    stroke: "#FFC20D",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.256 32.408L17.486 29.654V25.702H22.002V27.342L27.788 23.992L22.002 20.658V22.298H17.486V18.346L22.256 15.592L32.056 21.246V26.754L22.256 32.408Z",
    fill: "#FFC20D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38 6V20",
    stroke: "#FFC20D",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13H45",
    stroke: "#FFC20D",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_89_959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBuyMiles);
export default __webpack_public_path__ + "static/media/menu-buy-miles.940825f460527b9119dd7f0c9a2193ed.svg";
export { ForwardRef as ReactComponent };